export default {
  dbu_common_quarter: 'Quarter',
  dbu_common_mobile_game: 'Mobile Game',
  dbu_common_pc_game: 'PC Game',
  dbu_common_console_game: 'Console Game',
  dbu_common_combine_game: 'PC & Console Game',
  dbu_common_days: 'Days',

  dbu_common_genre_action: 'Action',
  dbu_common_genre_adventure: 'Adventure',
  dbu_common_genre_casual: 'Casual',
  dbu_common_genre_rpg: 'RPG',
  dbu_common_genre_racing: 'Racing',
  dbu_common_genre_shooter: 'Shooter',
  dbu_common_genre_simulation: 'Simulation',
  dbu_common_genre_software: 'Software',
  dbu_common_genre_sports: 'Sports',
  dbu_common_genre_strategy: 'Strategy',

  dbu_common_upload: 'Upload',
  dbu_common_download: 'Download',
  dbu_common_save: 'Save',
  dbu_common_back: 'Back',
  dbu_common_preview: 'Preview',
  dbu_common_share: 'Share',
  dbu_common_publish: 'Publish',
  dbu_common_draft: 'Draft',
  dbu_common_switch_en: 'Switch to English',
  dbu_common_switch_cn: 'Switch to Chinese',
  dbu_common_delete_success_tips: 'Delete successfully',
  dbu_common_delete_failure_tips: 'Delete failure',
  dbu_common_update_time: 'Update Time',
  dbu_common_reports: 'Reports',
  dbu_common_report: 'Report',
  dbu_common_cover: 'Cover',
  dbu_common_upload_img: 'Upload Image',
  dbu_common_upload_img_placeholder: 'Please upload the cover',
  dbu_common_delete_confirm_title: 'Are you sure to delete this file?',
  dbu_common_delete_confirm_desc: 'It will not be restored after deletion.',
};
